import React from "react";

const StatusCardSkeleton = () => {
  return (
    <div className=" h-[10rem] w-52 animate-pulse bg-gray-300 dark:bg-dashboardBg"></div>
  );
};

export default StatusCardSkeleton;
